export const MerchandiseTypes = [
    { key: 0, text: "Undefined" },
    { key: 1, text: "Tarif" },
    { key: 2, text: "Hardware" },
    { key: 3, text: "Option" },
    { key: 4, text: "TarifandSub" }
];